export default class Faculty {
    id: number;
    code: string;
    name: string;
    order: number;

    faculties: Faculty[];

    isChild: boolean;

    get display() {
        return this.name;
    }

    constructor(data: Partial<Faculty>) {
        Object.assign(this, data);

        if (!this.faculties) this.faculties = [];
        this.faculties = this.faculties.map(f => new Faculty(f));
    }
}
